<template>
  <admin-chart
    :links-clicked="linksClicked"
    :links-clicked-loading="linksClickedLoading"
    :device-opens="opensByDevice"
    :device-opens-loading="opensByDeviceLoading"
    :data-range="dataRange"
  />
</template>

<script>

import { ranges } from '@/components/Widgets/Reports/DataRangeSelector';
import AdminChart from './AdminChart';

export default {

  name: 'AdminTopInformationContainer',
  components: {
    AdminChart,
  },
  props: {
    dataRange: {
      type: String,
      required: true,
    },
  },
  computed: {
    institution() {
      if (!this.$store.state.institutions.item) {
        return {};
      }
      return this.$store.state.institutions.item;
    },
    institutionId() {
      return this.$store.state.account.user.profile.institution.pk;
    },
    opensByDevice() {
      const rates = this.$store.state.institutions.deviceOpens;
      return [{
        name: 'Desktop',
        value: rates.desktop_open_rate_range * 100,
      }, {
        name: 'Mobile',
        value: rates.mobile_open_rate_range * 100,
      }, {
        name: 'Tablet',
        value: rates.tablet_open_rate_range * 100,
      }];
    },
    opensByDeviceLoading() {
      return this.$store.state.institutions.isLoadingDeviceOpens;
    },
    linksClicked() {
      if (!this.institution || !this.institution.top_links) {
        return [];
      }
      return this.institution.top_links;
    },
    linksClickedLoading() {
      return this.$store.state.institutions.isLoading;
    },
    dataRangeIndex() {
      return ranges.indexOf(this.dataRange) - 1;
    },
  },
  watch: {
    dataRange(newval) {
      this.fetchDeviceOpens();
    },
  },
  mounted() {
    this.fetchDeviceOpens();
  },
  methods: {
    fetchDeviceOpens() {
      this.$store.dispatch('institutions/fetchDeviceOpens', { id: this.institutionId, range: this.dataRange });
    },
  },

};
</script>

  <style lang="css" scoped>
  </style>
